import { ProjectItemCapacityOverrideBase } from './base/project-item-capacity-override-base';

export class ProjectItemCapacityOverride extends ProjectItemCapacityOverrideBase { }